<template lang="pug">
  section.section-3#geography
    .info(v-if="lang==='ru'")
      .container-fluid
        .info__title
          template
            h2.title(v-if="!showRoutes") География
            .route(v-else)
              span(@click="toggle") География
          template
          .route(v-if="!showRoutes")
            span(@click="toggle") Маршруты
          h2.title(v-else) Маршруты
        .info__wrapper-list
          ul.info__list(v-if="!showRoutes")
            li.info__item
              .info__item__arrow
                svg.info__item__arrow--svg
                  use(xlink:href="#arrow--sprite")
              .info__item__text Транзитные перевозки Китай – Европа – Китай через сухопутные погран. переходы Эрлянь/Замын-Ууд – Наушки и Забайкальск
            li.info__item
              .info__item__arrow
                svg.info__item__arrow--svg
                  use(xlink:href="#arrow--sprite")
              .info__item__text Импортные перевозки в Россию через погран. переходы Эрлянь/Замын-Ууд – Наушки,  Забайкальск, Гродеково и порты Владивосток и Восточный
            li.info__item
              .info__item__arrow
                svg.info__item__arrow--svg
                  use(xlink:href="#arrow--sprite")
              .info__item__text Экспортные перевозки из России через погран. переходы Эрлянь/Замын-Ууд – Наушки,  Забайкальск, Гродеково и порты Владивосток и Восточный
            li.info__item
              .info__item__arrow
                svg.info__item__arrow--svg
                  use(xlink:href="#arrow--sprite")
              .info__item__text Внутрироссийские перевозки из Москвы в Красноярск, Иркутск, Хабаровск, Владивосток
          .info__routes(v-else)
            .info__table
              .info__table__thead
                .info__table__tr
                  .info__table__td Маршруты
                  .info__table__td Время в пути, дней
              .info__table__tbody
                .info__table__tr(@click="showLine(item)", v-for="(item, key) in routes1", :key="key", :class="{ 'active': activeRoute === item.id }")
                  .info__table__td {{item.name}}
                  .info__table__td {{item.days}}
    .info(v-if="lang==='en'")
      .container-fluid
        .info__title
          template
            h2.title(v-if="!showRoutes") Geography
            .route(v-else)
              span(@click="toggle") Geography
          template
          .route(v-if="!showRoutes")
            span(@click="toggle") Routes
          h2.title(v-else) Routes
        .info__wrapper-list
          ul.info__list(v-if="!showRoutes")
            li.info__item
              .info__item__arrow
                svg.info__item__arrow--svg
                  use(xlink:href="#arrow--sprite")
              .info__item__text Transit traffic China - Europe - China via land border crossings Erlian / Zamyn-Uud - Naushki and Zabaikalsk
            li.info__item
              .info__item__arrow
                svg.info__item__arrow--svg
                  use(xlink:href="#arrow--sprite")
              .info__item__text Import to Russia via land border crossings Erlian / Zamyn-Uud - Naushki, Zabaikalsk, Grodekovo and marine terminals in Vladivostok and Vostochny
            li.info__item
              .info__item__arrow
                svg.info__item__arrow--svg
                  use(xlink:href="#arrow--sprite")
              .info__item__text Export from Russia via land border crossings Erlian / Zamyn-Uud - Naushki, Zabaikalsk, Grodekovo and marine terminals in Vladivostok and Vostochny
            li.info__item
              .info__item__arrow
                svg.info__item__arrow--svg
                  use(xlink:href="#arrow--sprite")
              .info__item__text Domestic transportation from Moscow to Krasnoyarsk, Irkutsk, Khabarovsk, Vladivostok
          .info__routes(v-else)
            .info__table
              .info__table__thead
                .info__table__tr
                  .info__table__td Routes
                  .info__table__td Days
              .info__table__tbody
                .info__table__tr(@click="showLine(item)", v-for="(item, key) in routes2", :key="key", :class="{ 'active': activeRoute === item.id }")
                  .info__table__td {{item.name}}
                  .info__table__td {{item.days}}
    .map
      svg.map__pathway(v-if="lang==='ru'")
        use(xlink:href="#map-pathway--sprite")
      svg.map__pathway(v-if="lang==='en'")
        use(xlink:href="#map-pathwayen--sprite")
</template>

<script>
  export default {
    name: 'Geography',
    data() {
      return {
        showRoutes: false,
        activeRoute: 1,
        prev: null,
        info1: [
          'Импортное сообщение из Китая  в Россию ',
          'Экспортное сообщение из России в Китай ',
          'Транзитное сообщение из Китая  в Европу ',
          'Транзитное сообщение из Европы в Китай ',
          'Внутригосударственное сообщение'
        ],
        info2: [
          'Импортное сообщение из Китая  в Россию ',
          'Экспортное сообщение из России в Китай ',
          'Транзитное сообщение из Китая  в Европу ',
          'Транзитное сообщение из Европы в Китай ',
          'Внутригосударственное сообщение'
        ],
        routes1: [
          { id: 1, name: 'Москва - Иркутск', days: 6 },
          { id: 2, name: 'Москва - Красноярск', days: 5 },
          { id: 3, name: 'Иркутск - Замын Ууд', days: 8 },
          { id: 4, name: 'Братск - Замын Ууд', days: 9 },
          { id: 5, name: 'Замын Ууд - Москва', days: 10 },
          { id: 6, name: 'Замын Ууд - Брест', days: 10 }
        ],
        routes2: [
          { id: 1, name: 'Moscow - Irkutsk', days: 6 },
          { id: 2, name: 'Moscow - Krasnoyarsk', days: 5 },
          { id: 3, name: 'Irkutsk - Zamyn-Üüd', days: 8 },
          { id: 4, name: 'Bratsk - Zamyn-Üüd', days: 9 },
          { id: 5, name: 'Zamyn-Üüd - Moscow', days: 10 },
          { id: 6, name: 'Zamyn-Üüd - Brest', days: 10 }
        ]
      }
    },
    methods: {
      toggle() {
        this.showRoutes = !this.showRoutes
        let el = document.getElementById('map-pathway--sprite')
        // this.showRoutes ? el.classList.remove('active') : el.classList.add('active')
        if (this.showRoutes) {
          el.classList.remove('active')
          el.classList.add('cls-1')
        } else {
          el.classList.remove('cls-1')
          el.classList.add('active')
        }
        el = document.getElementById('map-pathwayen--sprite')
        // this.showRoutes ? el.classList.remove('active') : el.classList.add('active')
        if (this.showRoutes) {
          el.classList.remove('active')
          el.classList.add('cls-1')
        } else {
          el.classList.remove('cls-1')
          el.classList.add('active')
        }
      },
      showLine({ id }) {
        document.getElementById('map-pathway--sprite').classList = ''
        document.getElementById('map-pathway--sprite').classList.add('cls-' + id)
        this.activeRoute = id
        document.getElementById('map-pathwayen--sprite').classList = ''
        document.getElementById('map-pathwayen--sprite').classList.add('cls-' + id)
        this.activeRoute = id
      }
    },
    mounted() {
      document.getElementById('map-pathway--sprite').classList.add('active')
      document.getElementById('map-pathwayen--sprite').classList.add('active')
    },
    props: {
      lang: String
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../style/variables";

  .title {
    margin-bottom: 0;
    font-size: 2.8vw;
    padding: 4.2vw 0 1.8vw;
    color: $color-title-red
  }
  .section-3 {
    margin: 4vw 0 8vw;
    position: relative;
    z-index: 4;
    min-height: 48.5vw;
    display: flex;
    background-color: #fff;
  }
  .info {
    z-index: 1;
    width: 43vw;
    position: relative;
    &__title {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .route {
        padding-bottom: 1.8vw;
        font-size: 1.7vw;
        span {
          cursor: pointer;
          user-select: none;
          border-bottom: .2vw dashed $color-links;
          &:hover {
            border-bottom-style: solid;
          }
        }
      }
    }
    &__wrapper-list {
      margin-top: 2vw;
    }
    &__list {
      margin: 0;
      padding: 0;
      list-style: none;
    }
    &__item {
      $s-arrow: 2.17vw;
      display: flex;
      font-size: 1.2vw;
      &:not(:last-child) {
        margin-bottom: 2.2vw;
      }
      &__arrow {
        margin-right: $s-arrow;
        &--svg {
          height: 1.7vw;
          width: $s-arrow;
        }
      }
    }
    &__routes {
      &__close {
        right: 0;
        top: 0;
        position: absolute;
      }
    }
    &__table {
      margin: 0 -2vw;
      &__tr {
        display: flex;
        user-select: none;
      }
      &__td {
        padding: 1.5vw 1.2vw;
        &:first-child {
          flex: 1;
          min-width: 17vw;
        }
      }
      &__thead {
        color: rgba($border-color, .7);
        font-weight: 300;
        .info__table__td {
          padding-top: .3vw;
          padding-bottom: .3vw;
        }
      }
      &__tbody {
        .info {
          &__table {
            &__tr {
              // border: .2vw solid transparent;
              position: relative;
              &:not(.active) {
                cursor: pointer;
              }
              &.active {
                z-index: 2;
                color: $color-title-red;
                // border: .2vw solid $border-color;
                background-color: rgba($border-color, .15);
              }
            }
          }
        }
      }
    }
  }
  .map {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 57vw;
    overflow: hidden;
    position: relative;
    background-size: 73vw;
    background-position: -15vw .2vw;
    background-image: url('~@/assets/map.png');
    background-repeat: no-repeat;
    &__pathway {
      fill: transparent;
      height: 26vw;
      width: 56vw;
    }
  }
</style>

<style lang="scss">
  @import "../../style/variables";
  $light-gray-color: rgba(180, 180, 180, .8);
  $anim: all .6s ease-in-out;
  #map-pathway--sprite {
    path, line, polyline {
      fill: transparent;
      stroke: $light-gray-color;
      transition: $anim;
    }
    circle, text {
      fill: $light-gray-color;
      transition: $anim;
    }
    text {
      font-size: .8rem;
    }

    &.active {
      path, line, polyline {
        stroke: $color-title-red;
      }
      circle, text {
        fill: $color-title-red;
      }
    }

    @for $i from 1 through 6 {
      &.cls-#{$i} {
        path.cls-#{$i}, line.cls-#{$i}, polyline.cls-#{$i} {
          stroke: $color-title-red;
        }
        circle.cls-#{$i}, text.cls-#{$i} {
          fill: $color-title-red;
        }
      }
    }
  }
  #map-pathwayen--sprite {
    path, line, polyline {
      fill: transparent;
      stroke: $light-gray-color;
      transition: $anim;
    }
    circle, text {
      fill: $light-gray-color;
      transition: $anim;
    }
    text {
      font-size: .8rem;
    }

    &.active {
      path, line, polyline {
        stroke: $color-title-red;
      }
      circle, text {
        fill: $color-title-red;
      }
    }

    @for $i from 1 through 6 {
      &.cls-#{$i} {
        path.cls-#{$i}, line.cls-#{$i}, polyline.cls-#{$i} {
          stroke: $color-title-red;
        }
        circle.cls-#{$i}, text.cls-#{$i} {
          fill: $color-title-red;
        }
      }
    }
  }
</style>
